import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const certificateExpiredTemplates = [
  {
    id: '-232001',
    language: Language.EN,
    subject: 'Certificate expired',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>The certificate {{certificateName}} for {{getBuildingNames buildings}} has expired. Please renew it as soon as possible.</p>
        `,
  },
  {
    id: '-232002',
    language: Language.FR,
    subject: 'Certificat expiré',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Le certificat {{certificateName}} pour {{getBuildingNames buildings}} a expiré. Veuillez le renouveler dès que possible.</p>
        `,
  },
  {
    id: '-232003',
    language: Language.NL,
    subject: 'Certificaat verlopen',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Het certificaat {{certificateName}} voor {{getBuildingNames buildings}} is verlopen. Gelieve het zo snel mogelijk te vernieuwen.</p>
        `,
  },
  {
    id: '-232004',
    language: Language.DE,
    subject: 'Zertifikat abgelaufen',
    type: TemplateType.SMS,
    subType: TemplateSubType.CERTIFICATE_EXPIRED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Das Zertifikat {{certificateName}} für {{getBuildingNames buildings}} ist abgelaufen. Bitte erneuern Sie es so schnell wie möglich.</p>
        `,
  },
];
